export default{
    data(){
        return{
            notas:[],
            somatoria:0,
            notasQuant:0,            
            spinerMedio:false,
            objEnviaNotas:{},
            temFiltro:false,
            objEnviaNotasNfe:{
                "idEmpresa":this.$store.state.idEmpresa,
                "quantidade":70,
                "numeroPagina":1,
                "tag":"DEST",
                "empresa": "",
                "dataInicial": "",
                "dataFinal": "",
                "valorMinimo": "",
                "valorMaximo": "",
                "ncm": "",
                "cst": "",
                "exportacao":false,
                "estadoEmissao":0,
            },
            objEnviaNotasCte:{                
                    "idEmpresa": this.$store.state.idEmpresa,
                    "quantidade": 70,
                    "numeroPagina": 1,
                    "dataInicial": "",
                    "dataFinal": "",
                    "tag": "Tomador" 
            },
            objEnviaNotasNFCe:{                
                "idEmpresa": this.$store.state.idEmpresa,  
                "quantidade": 100,
                "numeroPagina": 1,
                "tag": 1               
        }
            
        }
    },
    methods:{      
            colocarParaFiltrar(valor,tipo){
                console.log(valor);
                if(tipo =='NFe'){
                    this.objEnviaNotasNfe.numeroPagina = 1
                this.objEnviaNotasNfe.dataInicial = valor.dataInicio
                 this.objEnviaNotasNfe.dataFinal = valor.dataFim
                 this.objEnviaNotasNfe.empresa = valor.emissora
                 this.objEnviaNotasNfe.valorMaximo = valor.max
                 this.objEnviaNotasNfe.valorMinimo = valor.min
                 this.objEnviaNotasNfe.ncm = valor.ncm
                 this.objEnviaNotasNfe.cst = valor.cst
                 this.objEnviaNotasNfe.estadoEmissao = parseInt(valor.estado)
                }else{
                    
                    this.objEnviaNotasCte.dataInicial = valor.dataInicio
                    this.objEnviaNotasCte.dataFinal = valor.dataFim
                }
          },
          zerarParaFiltro(){
            this.objEnviaNotasNfe.dataInicial = ""
            this.objEnviaNotasNfe.dataFinal = ""
            this.objEnviaNotasNfe.empresa = ""
            this.objEnviaNotasNfe.valorMaximo = ""
            this.objEnviaNotasNfe.valorMinimo = ""
            this.objEnviaNotasNfe.ncm = ""
            this.objEnviaNotasNfe.cst = ""
            this.objEnviaNotasCte.dataInicial =""
            this.objEnviaNotasCte.dataFinal = ""
          }
    }
}